import { useEffect, useState } from 'react';
import { onValue, query, ref, orderByChild, startAt } from 'firebase/database';
import { db } from '@/shared/firebase/config';
import type { TrackedLatest } from '@/shared/firebase/types';

export function useLocationHistory(
  centerId: string | null,
  uid: string | null,
  sinceMs: number,
) {
  const [points, setPoints] = useState<TrackedLatest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!centerId || !uid) {
      setPoints([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const cutoff = Date.now() - sinceMs;
    const q = query(
      ref(db, `centers/${centerId}/tracked/${uid}/locations`),
      orderByChild('ts'),
      startAt(cutoff),
    );
    return onValue(
      q,
      (snap) => {
        const v = snap.val() as Record<string, TrackedLatest> | null;
        const list = v
          ? Object.values(v)
              .filter(
                (p) =>
                  typeof p?.lat === 'number' &&
                  typeof p?.lng === 'number' &&
                  typeof p?.ts === 'number',
              )
              .sort((a, b) => a.ts - b.ts)
          : [];
        setPoints(list);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, [centerId, uid, sinceMs]);

  return { points, loading };
}
